export const MODAL_TYPE = Object.freeze({
  ADD_AND_SAVE_MODAL: 'add-and-save',
  PROMOTION_AWARENESS: 'promotion-awareness',
  ECONOMIC_PLAN_EXPIRED: 'economic-plan-expired',
  FLEX_MODE_ONBOARDING_MODAL: 'you-are-on-flex-mode',
  CHALLENGE_COACHMARK: 'challenge-coachmark',
  RATE_FIRST_DELIVERY_MODAL: 'rate-first-delivery',
  COACH_MARK_CALENDAR_VIEW: 'coach-mark-calendar-view',
  EARLY_USER_ONBOARDING_COACHMARK: 'early-user-onboarding-coachmark',
  CHANGE_DELIVERY_MODAL: 'change-delivery',
  ECONOMIC_PLAN_FOREVER: 'economic-plan-forever-modal',
  SKIP_DEFLECTION_COACHMARK: 'skip-deflection',
  SKIP_DEFLECTION_CART_COACHMARK: 'skip-deflection-cart',
  MONTHLY_PLAN_MODAL: 'monthly-plan-modal',
  MONTHLY_PREPAY_ONBOARDING_MODAL: 'monthly-prepay-onboarding-modal',
  UPGRADE_PLAN_WITH_PROMOTION_MODAL: 'upgrade-plan-with-promotion-modal'
})
export const COMPARE_PLANS_LOCALSTORAGE_KEY = 'tour-compare-plans-modal-viewed'
export const MONTHLY_MODAL_STEPS = {
  PAY_IN_ADVANCE: 'PAY_IN_ADVANCE',
  CONFIRM_YOUR_PLAN: 'CONFIRM_YOUR_PLAN',
  ACTIVATE: 'ACTIVATE',
  REACTIVATED: 'REACTIVATED',
  FAQ: 'FAQ'
}
